import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import {
  ORGANISATION_CONTACTS_RESOURCE,
  ORGANISATION_CONTACT_RESOURCE,
  UPDATE_ORGANISATION_CONTACT_RESOURCE,
} from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_ORGANISATION_CONTACT_RESOURCE,
      method: 'put',
      request: (orgId, id, body, callback, t) => ({
        url: apiRoutes.organisationContacts(orgId, id),
        body,
        meta: {
          callback,
          updateOtherList: {
            resource: ORGANISATION_CONTACTS_RESOURCE,
            idProp: 'id',
            id,
          },
          setOther: {
            resource: ORGANISATION_CONTACT_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updateContactFailed'),
            onSuccessMessage: t('updateContactSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);
